import React, { useState, useRef } from "react";

export default function TagInputField({
  value = [],
  onChange,
  placeholder = "Add tag...",
  handleEnableEdit,
  input,
  inputMaxLength,
  setInput,
  addTagValidation,
  disabled
}) {

  const [activeTagIndex, setActiveTagIndex] = useState(null);

  const inputRef = useRef();

  const valuelength = value?.length;

  // Add tag
  const addTag = (tag) => {
    const newTag = tag?.trim();

    if (!newTag) return;
    if (!addTagValidation()) return;

    onChange([...value, newTag]);
    setInput("");
    setActiveTagIndex(null);
    handleEnableEdit()
  };

  // Remove tag
  const removeTag = (index) => {
    const newTags = value?.filter((_, i) => i !== index);
    onChange(newTags);
    setActiveTagIndex(null);
    handleEnableEdit()
  };

  const handleKeyDown = (e) => {

    // ENTER or COMMA creates tag
    if (e?.key === "Enter" || e?.key === ",") {
      e?.preventDefault();
      addTag(input);
    }

    // BACKSPACE or DELETE behavior
    if ((e?.key === "Backspace" || e?.key === "Delete") && input === "") {

      // First press selects last tag
      if (activeTagIndex === null && valuelength > 0) {
        setActiveTagIndex(valuelength - 1);
        return;
      }

      // Second press removes selected tag
      if (activeTagIndex !== null) {
        removeTag(activeTagIndex);
      }
    }

    // Arrow navigation
    if (e?.key === "ArrowLeft" && input === "") {
      if (activeTagIndex === null) {
        setActiveTagIndex(valuelength - 1);
      } else {
        setActiveTagIndex(Math.max(0, activeTagIndex - 1));
      }
    }
    if (e?.key === "ArrowRight" && input === "" && activeTagIndex !== null) {
      setActiveTagIndex(Math.max(0, activeTagIndex + 1));
    }

  };

  return (
    <div
      className={`tag_container form-control ${disabled ? "tag_container_disable" : ""}`}
      onClick={() => inputRef?.current?.focus()}
    >
      {value?.map((tag, index) => (
        <span
          key={index}
          className={`tag ${activeTagIndex === index ? "active" : ""}`}
        >
          {tag}
          <button onClick={() => !disabled && removeTag(index)} disabled={disabled} > &times; </button>
        </span>
      ))}

      <input
        ref={inputRef}
        value={input}
        onChange={(e) => {
          if (e.target.value?.length <= inputMaxLength) {
            setInput(e?.target?.value);
            setActiveTagIndex(null);
            handleEnableEdit()
          }
        }}
        onKeyDown={(e) => e.target.value?.length <= inputMaxLength && handleKeyDown(e)}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={inputMaxLength}
      />
    </div>
  );
}